(function () {
  let depthProfileGraph;

  const scales = {
    3: {
      // breaks: [11, 10, 9, 8, 7, 6, 5, 5],
      // colors: ['#4e65ac', '#6869af', '#5ca7ba', '#addeac', '#e1f3aa', '#f6fbb5', '#ff9b93', '#d45c53'],

      breaks: [0, 5, 6, 7, 8, 9, 10, 11],
      colors: ['#d45c53', '#ff9b93', '#f6fbb5', '#e1f3aa', '#addeac', '#5ca7ba', '#6869af', '#4e65ac'],
    }, // DO 
    8: {
      breaks: [0, 5, 10, 15, 20, 26.2, 29.3, 29.3],
      colors: ['#4e65ac', '#6869af', '#5ca7ba', '#addeac', '#e1f3aa', '#f6fbb5', '#ff9b93', '#e6665c'],
    }, // Temp
    7: {
      breaks: [7, 7.5, 8, 8.5, 9, 9.5, 10],
      colors: ['#4E65AC', '#6869AF', '#5CA7BA', '#ADDEAC', '#F6FBB5', '#FF9B93', '#E6665C'], 
    }, // pH
    // "100139": {breaks: [0, 2, 4, 6, 7.12, 10, 30],colors: ["#4e65ac","#5ca7ba","#addeac","#e1f3aa","#f6fbb5","#ff9b93","#d45c53"],
    // }, // TDN:TDP Ratios
    100139: {
      breaks: [0, 3.5, 7.12, 10, 15, 20, 25],
      colors: ['#d45c53', '#ff9b93', '#f6fbb5', '#e1f3aa', '#addeac', '#5ca7ba', '#4e65ac'],
    }, // TDN:TDP Ratios
    100138: {
      breaks: [0, 3.5, 7.12, 10, 15, 20, 25],
      colors: ['#d45c53', '#ff9b93', '#f6fbb5', '#e1f3aa', '#addeac', '#5ca7ba', '#4e65ac'],
    }, // TN:TP Ratios
    100140: {
      breaks: [0, 3.5, 7.12, 10, 15, 20, 25],
      colors: ['#d45c53', '#ff9b93', '#f6fbb5', '#e1f3aa', '#addeac', '#5ca7ba', '#4e65ac'],
    }, // TIN:SRP Ratios
  };

  // "#d45c53", "#ff9b93", "#f6fbb5", "#e1f3aa", "#addeac", "#5ca7ba", "#4e65ac"

  /**
   * This function is used as shorthand for creating a Mercury Form filter control
   * @param  {string} type  [type of filter to create i.e. dropdown or date filter]
   * @param  {string} label [label to display above filter]
   * @return {object}       [returns a mercury form object]
   */
  function createFilter(type, label) {
    let options = {
      parentContainer: '#filters-wrapper',
      label: label,
    };

    if (type === 'date') {
      return new datePicker(options);
    } else if (type === 'dropdown') {
      return new Dropdown(options);
    }
  }

  /**
   * This function is used to bind the onChange event for each filter
   * The function loops through each filter and binds the createResultRequest function to the filter
   * @return {[type]} [description]
   */
  function bindFilterEvents() {
    const filters = [startDate, endDate, location, parameter];
    filters.forEach(filter => {
      filter.onChange = () => {
        createResultRequest(startDate.getDate(), endDate.getDate(), location.val(), parameter.val());
      };
      filter.bindEvents();
    });
  }

  // Create an async function as a shorthand for resolving fetch requests
  async function fetchData(url) {
    let response = await fetch(url);
    let json = await response.json();
    return json;
  }

  function createResultRequest(startDate, endDate, loc, param) {
    const resultsPromise = fetchData(
      `sites/all/scripts/view/depth-profile.php?table=viewer.depth_profile_graph_data&fields%5B%5D=rdate&fields%5B%5D=*&location=${loc}&parameter=${param}&sort=rdate,depth_value`
    );

    resultsPromise.then(data => {
      const filteredData = data.filter(d => {
        return (
          new Date(`${startDate} 00:00:00`).getTime() <= new Date(d.rdate).getTime() &&
          new Date(`${endDate} 00:00:00`).getTime() >= new Date(d.rdate).getTime()
        );
      });

      if (filteredData.length > 0) {
        const formattedData = filteredData.map(d => {
          return {
            rdate: d.rdate,
            depth_value: parseInt(d.depth_value),
            rvalue: +d.rvalue_converted,
            unit_name: d.unit_name,
            parameterid: d.parameterid,
          };
        });
        depthProfileGraph.setData(formattedData);
        depthProfileGraph.scale = scales[param];
        depthProfileGraph.draw();
      } else {
        depthProfileGraph.removeSVG(
          '<h4 class="text-center">No data returned for the current selections. Please update the filters and try again</h4>'
        );
      }
    });
  }

  // Create filters
  const startDate = createFilter('date', 'Start Date');
  const endDate = createFilter('date', 'End Date');
  const location = createFilter('dropdown', 'Location');
  const parameter = createFilter('dropdown', 'Parameter');

  startDate.setDate('2023-10-01');
  endDate.setDate('2024-09-30');
  bindFilterEvents();

  // Create data requests
  const locationPromise = fetchData(
    'sites/all/scripts/activeDataFilters.php?table=viewer.download_dropdown_locs&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false'
  );
  const parameterPromise = fetchData(
    'sites/all/scripts/activeDataFilters.php?table=viewer.list_parameters_dropdown_simple&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false'
  );

  const resultsPromise = fetchData(
    'sites/all/scripts/view/depth-profile.php?table=viewer.depth_profile_graph_data&fields%5B%5D=rdate&fields%5B%5D=*&location=80&parameter=3&sort=rdate,depth_value'
  );

  // Populate location dropdown
  locationPromise.then(data => {
    const locations = [79, 80, 81, 120];
    location.data = data.filter(d => locations.includes(d.stored));
    location.buildDropdown();
    location.val(80);
  });

  // Populate the parameter dropdown
  parameterPromise.then(data => {
    const parameters = [
      20, 634, 638, 25, 24, 2, 42, 10, 6, 29, 45, 50, 1, 27, 16, 11, 3, 680, 1892, 28, 46, 47, 652, 19, 30, 100139,
      100140, 100138, 8, 53, 9, 7,1902
    ];
    parameter.data = data.filter(d => parameters.includes(d.stored));
    parameter.buildDropdown();
    parameter.val(3);
  });

  // Request initial data from the DB
  resultsPromise.then(data => {
    const extent = d3.extent(data, d => +d.rvalue_converted);
    const filteredData = data.filter(d => {
      return (
        new Date('2019-01-01 00:00:00').getTime() <= new Date(d.rdate).getTime() &&
        new Date('2021-12-31 00:00:00').getTime() >= new Date(d.rdate).getTime()
      );
    });

    const formattedData = filteredData.map(d => {
      return {
        rdate: d.rdate,
        depth_value: d.depth_value,
        rvalue: +d.rvalue_converted,
        unit_name: d.unit_name,
        parameterid: d.parameterid,
      };
    });

    depthProfileGraph = new Heatmap({
      container: '#depth-profile-chart',
      data: formattedData,
      xAxis: {
        enabled: true,
      },
      scale: scales['3'],
    });
    depthProfileGraph.draw();
  });
})();
